module.exports = __webpack_public_path__ + "static/img/glsmall01.8704040e.jpg";